import { faHome, faFileInvoiceDollar } from "@fortawesome/pro-light-svg-icons"
import { NavMenuItem } from "../../../../shared/layouts/components/NavMenuItem"
import { LocalizedStrict } from "../../../localization/components/AppLocalized"
import {
    TENANT_ACCOUNTING_MEETING_SERVICE_ROUTE,
    TENANT_ACCOUNTING_POS_ROUTE,
    TENANT_ACCOUNTING_ROUTE,
    TENANT_ACCOUNTING_SUBSCRIPTIONS_ROUTE,
    TENANT_REPORTS_ROUTE,
} from "../../../../constants/routes"
import { NavMenuItemGroupWrapper, NavMenuSubItem } from "../../../../shared/layouts/components/NavMenuItemGroup"
import { MatchEnvironment } from "../../../environment/components/MatchEnvironment"
import { EnvironmentType } from "../../../environment/envTypes"

export function TenantReportNavItems() {
    return (
        <>
            <LocalizedStrict id="tenant-nav-item-home">
                <NavMenuItem icon={faHome} dest={TENANT_REPORTS_ROUTE}>
                    Home
                </NavMenuItem>
            </LocalizedStrict>

            <LocalizedStrict id="tenant-nav-item-accounting" attrs={{ title: true }}>
                <NavMenuItemGroupWrapper icon={faFileInvoiceDollar} dest={TENANT_ACCOUNTING_ROUTE} title="Accounting">
                    <LocalizedStrict id="tenant-nav-item-pos">
                        <NavMenuSubItem route={TENANT_ACCOUNTING_POS_ROUTE}>POS</NavMenuSubItem>
                    </LocalizedStrict>
                    <MatchEnvironment
                        environments={[EnvironmentType.Local, EnvironmentType.Test, EnvironmentType.Demo]}
                    >
                        <LocalizedStrict id="tenant-nav-item-meeting-service">
                            <NavMenuSubItem route={TENANT_ACCOUNTING_MEETING_SERVICE_ROUTE}>
                                Meeting service
                            </NavMenuSubItem>
                        </LocalizedStrict>
                        <LocalizedStrict id="tenant-nav-item-subscriptions">
                            <NavMenuSubItem route={TENANT_ACCOUNTING_SUBSCRIPTIONS_ROUTE}>Subscriptions</NavMenuSubItem>
                        </LocalizedStrict>
                    </MatchEnvironment>
                </NavMenuItemGroupWrapper>
            </LocalizedStrict>
        </>
    )
}
